// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8d79469c81b9a7f50c93d1405bf9ceb507bcac5c/static/css/" + chunkId + "." + {"252":"ddced95f","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};